module.exports = __webpack_public_path__ + "./debby-illustration_0c5450b7334da319034e7654c38a1623.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/debby-illustration.png
// module id = 428
// module chunks = 0